<template>
	<sub-dialog ref="linkDialog" title="选择链接" width="650" @resolve="resolve">
		<sub-form v-if="initialized" ref="form" style="height: 430px; padding: 30px;">
			<div style="width: 400px;">
				<sub-form-item v-model="type" type="select" label="跳转类型" name="type" :options="typeOptions"></sub-form-item>
				<sub-form-item v-show="type == '0'" type="select" label="系统页" name="systemPage" :options="systemPageList"></sub-form-item>
				<sub-form-item v-show="type == '5'" type="select" label="装修页" name="decoratePage" :options="decoratePageList"></sub-form-item>
				<sub-form-item v-show="type == '7'" type="input" label="关键词" name="keyword"></sub-form-item>
				<sub-form-item v-show="type == '7'" type="select" label="品牌" name="product_brand_id" options="BRAND"></sub-form-item>
				<sub-form-item v-show="type == '7'" type="select" label="类目" name="product_type_id" options="PRODUCT_CLASSIFY"></sub-form-item>
			</div>
			
			<div v-show="type == '8'" class="product-list">
				<div class="search flex-end-center">
					<sub-input v-model="productName" placeholder="商品名称"></sub-input>
					<sub-input v-model="productNumber" placeholder="货号"></sub-input>
					<sub-button @click="$refs.productPagination.update(1)">查询</sub-button>
				</div>
				<ul>
					<li v-for="(item, i) in productList" :key="item.product_id" class="flex-center">
						<sub-image v-if="item.product_img_url" class="image" :src="item.product_img_url"></sub-image>
						<div class="info flex-grow">
							<p class="ellipsis">{{item.product_itemnumber ? `【${item.product_itemnumber}】` : ''}}{{item.product_name}}</p>
							<p>￥{{item.product_price}}</p>
						</div>
						<div class="op">
							<a @click="currentProduct = item">{{currentProduct.product_id == item.product_id ? '取消' : ''}}选择</a>	
						</div>
					</li>
				</ul>
				<pagination ref="productPagination" size="5" :total="productTotal" :border="false" style="padding: 0 8px; margin: 0;" @handle="updateProductList"></pagination>
			</div>
		</sub-form>
	</sub-dialog>
</template>

<script>
	import pagination from '@/submodule/components/public/pagination.vue'
	
	export default {
		components: {
			pagination
		},
		
		data() {
			return {
				initialized: false,
				typeOptions: [],
				type: '',
				systemPageList: [],
				decoratePageList: [],
				productList: [],
				productTotal: 0,
				currentProduct: {},
				
				productName: '',
				productNumber: ''
			}
		},
		
		watch: {
			type(val) {
				if (val == 8) {
					this.productName = this.productNumber = '';
					this.$refs.productPagination.update(1);
				}
			}
		},
		
		methods: {
			init() {
				if (!this.initialized) {
					this.initialized = true;
					this.request({
						url: '/decoration/common/page_type',
						success: data => {
							this.typeOptions = Array.from(data, item => {
								return {
									name: item.name,
									value: item.businessType.toString()
								}
							});
							this.init();
						}
					});
				} else {
					this.update();
					this.$nextTick(() => {
						this.$refs.form.clear();
						this.currentProduct = {};
						this.$refs.form.set({
							type: this._value[0]
						});
						
						if (this._value[0] == '7') {
							this.$refs.form.set(JSON.parse(this._value[1]));
						} else if (this._value[0] == '8') {
							this.currentProduct = {
								product_id: this._value[1],
								product_name: this._value[2]
							}
						}
					})
				}
			},
			
			config(value, config) {
				this._value = value ? value.split('#link#') : [];
				this._config = config;
				this.init();
				this.$refs.linkDialog.open();
			},
			
			update() {
				this.request({
					url: '/decoration/common/sys_page',
					data: {
						support_flag: this._config.type
					},
					success: data => {
						this.systemPageList = Array.from(data, item => {
							return {
								name: item.name,
								value: item.id.toString()
							}
						});
						if (this._value[0] == '0') {
							this.$refs.form.set({
								systemPage: this._value[1]
							});
						}
					}
				});
				this.request({
					url: '/decoration/common/page',
					data: {
						support_flag: this._config.type,
						template_id: this._config.template
					},
					success: data => {
						this.decoratePageList = Array.from(data, item => {
							return {
								name: item.name,
								value: item.id.toString()
							}
						});
						if (this._value[0] == '5') {
							this.$refs.form.set({
								decoratePage: this._value[1]
							});
						}
					}
				});
			},
			
			updateProductList(data) {
				this.request({
					url: '/product/list',
					data: Object.assign(data, {
						product_name: this.productName,
						product_itemnumber: this.productNumber,
						pageSize: 10,
						stationed_type: this.sub.saas ? 2 : 1
					}),
					success: data => {
						this.productList = data || [];
					},
					response: res => {
						this.productTotal = res.total;
					}
				});
			},
			
			resolve(stop, next) {
				stop();
				let data = this.$refs.form.serialize();
				let error = '';
				
				if (!data.type) {
					error = '请选择跳转类型';
				}
				
				let arr = [data.type];
				
				switch(data.type) {
				case '0':
					if (!data.systemPage) {
						error = '请选择系统页'
					} else {
						arr.push(data.systemPage, this.systemPageList.find(item => item.value == data.systemPage).name);
					}
					break;
					
				case '5':
					if (!data.decoratePage) {
						error = '请选择装修页'
					} else {
						arr.push(data.decoratePage, this.decoratePageList.find(item => item.value == data.decoratePage).name);
					}
					break;
					
				case '7':
					arr.push(JSON.stringify({
						keyword: data.keyword,
						product_brand_id: data.product_brand_id,
						product_type_id: data.product_type_id
					}));
					break;
					
				case '8':
					if (!this.currentProduct.product_id) {
						error = '请选择一个商品'
					} else {
						arr.push(this.currentProduct.product_id, this.currentProduct.product_name);
					}
					break;
				}
				
				if (error) {
					this.sub.$message({
						text: error
					});
					return;
				}
				this._config.resolve(arr.join('#link#'));
				next();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.product-list {
		padding: 0 10px 10px;
		background: #F5F5F5;
		
		.search {
			gap: 10px;
			padding: 10px 0;
		}
		
		ul {
			height: 285px;
			overflow: auto;
			background: #fff;
			
			li {
				border-bottom: 1px solid #E9E9E9;
				padding: 7px 10px;
				
				.image {
					width: 50px;
					height: 50px;
					margin-right: 10px;
				}
				
				.info {
					margin-right: 10px;
					line-height: 20px;
					font-size: 13px;
					color: #444;
				}
				
				.op {
					width: 5em;
					line-height: 52px;
					font-size: 12px;
					color: #ff803d;
				}
			}
		}
	}
</style>